module.exports = __webpack_public_path__ + "img/03_tribesh-kayastha.497db175.jpg";